import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { WinterWeatherGraph } from './WinterWeatherGraph'
import styles from './WinterWeatherReport.module.css'

export function WinterWeatherReport() {
  const intl = useIntl()
  const report = useCMSPageField('ContentPage.winterWeatherReport')

  if (!report)
    return null

  const baseDescription = intl.formatMessage(
    { id: 'content_weather_report_description' },
    { destinationName: report.destinationName ?? '' },
  )
  const description = [baseDescription, report.description?.trim()].filter(Boolean).join(' ')

  return (
    <section className={styles.root} aria-labelledby="winter-weather-report-title">
      <div className={styles.introduction}>
        <Typography id="winter-weather-report-title" as="h2" variant="display-e-regular">
          {intl.formatMessage({ id: 'content_weather_report_title' })}
        </Typography>
        <Typography as="p" variant="body-m-regular-snug">
          {description}
        </Typography>
      </div>

      <div className={styles.content}>
        <WinterWeatherGraph
          months={report.months}
          minAltitudeMeters={report.minAltitudeMeters}
          maxAltitudeMeters={report.maxAltitudeMeters}
        />
      </div>
    </section>
  )
}
